
export default {
  name: 'AtomRequestOfferButton'
}
